const GlobalConstant = Object.freeze({
   // Staging URL
   // API_URL: "https://dbixstaging.kl.his.edu.my",
   // SAML_URL: "https://dbixstaging.kl.his.edu.my",
   // LOGIN_IMAGE: "swimming_staging.jpeg",
   // PORTAL_URL: "https://payment-staging.kl.his.edu.my/Login",

   // Production
   API_URL: "https://dbixapi.kl.his.edu.my",
   SAML_URL: "https://dbixapi.kl.his.edu.my",
   LOGIN_IMAGE: "swimming.jpeg",
   PORTAL_URL: "https://payment.kl.his.edu.my/Login",

   // Development
   // API_URL: "http://localhost:8080",
   // SAML_URL: "https://help-api.horecabid.com",
   // LOGIN_IMAGE: "swimming_staging.jpeg",
   // PORTAL_URL: "http://localhost:8083/Login",

   APP_LONGNAME: "Co-Curricular Activity Portal",
   APP_SHORTNAME: "CCA Portal",

   CAPMASTER_RANGE: [1000, 1999],
});

export default GlobalConstant;
